import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import moment from "moment";

import {
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

import useAuth from "../../hooks/useAuth";
import { useAppDispatch } from "../../hooks/store";
import MainContainer from "../../layout/MainContainer";

import Pagination from "../../components/Pagination";
import WarnModal from "../../components/modals/WarnModal";
import SearchBar from "../../components/SearchBar";
import Loader from "../../constants/Loader";

import { STORAGE_KEYS, getFromStorage } from "../../helpers";
import { handleDelete, updateStatus } from "../../utils/commonFunctions";
import { isValidInput } from "../../utils/validation";
import { Banner } from "../../types/General";

import {
  useLazyDeleteBannerByIdQuery,
  useLazyGetBannerQuery,
  useUpdateBannerStatusMutation,
} from "../../services/main";
import { setCredentials } from "../../reducers/authSlice";

export default function ManageBanner() {
  const user = useAuth();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [getBanner, { isLoading }] = useLazyGetBannerQuery();
  const [deleteById] = useLazyDeleteBannerByIdQuery();
  const [updateStatusMutation] = useUpdateBannerStatusMutation();

  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [banners, setBanners] = useState<Banner[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const label = { inputProps: { "aria-label": "Switch demo" } };

  let totalPages = Math.ceil(totalCount / 10);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getAllBanner = async () => {
    setLoading(true);

    const token = getFromStorage(STORAGE_KEYS.token);

    dispatch(
      setCredentials({
        user: user,
        token: token,
      })
    );

    try {
      const res = await getBanner({
        size: 10,
        page: page,
        query: debouncedSearchTerm.trim(),
      }).unwrap();

      if (res?.statusCode === 200) {
        setLoading(false);
        setBanners(res?.data?.data || []);
        setTotalCount(res?.data?.count);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllBanner();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer name="Contact & Support">
      <Loader isLoad={isLoading || loading} />
      <div className="manage_blog">
        <div className="sec_head fs_22">
          <h2>Manage Banner</h2>
          <div className="btn_group1">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            {banners?.length === 5 ? null : (
              <div className="add_btn">
                <button
                  className="btn btn_primary"
                  onClick={() => navigate("/manage-banner/add")}
                >
                  <AddIcon />
                </button>
              </div>
            )}
          </div>
        </div>
        <TableContainer className="table_container">
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="table"
          >
            <TableHead>
              <TableRow>
                <TableCell align="center">S.No</TableCell>
                <TableCell>Banner Title</TableCell>
                <TableCell>Banner Created At</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {banners?.length
                ? banners?.map((row, i) => (
                    <TableRow>
                      <TableCell align="center">
                        {(page - 1) * 10 + i + 1}
                      </TableCell>
                      <TableCell>{row?.title || ""}</TableCell>
                      <TableCell>
                        {row?.createdAt
                          ? moment(row?.createdAt).format("LL")
                          : ""}
                      </TableCell>
                      <TableCell>
                        <Switch
                          {...label}
                          size="small"
                          checked={!row?.isBlocked}
                          onChange={() =>
                            updateStatus(
                              row?._id,
                              !row?.isBlocked,
                              updateStatusMutation,
                              setBanners,
                              banners
                            )
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <ul className="action_btn">
                          <li
                            onClick={() =>
                              navigate(`/manage-banner/edit/${row?._id}`)
                            }
                          >
                            <button type="button">
                              <EditIcon />
                            </button>
                          </li>
                          {/* <li>
                          <button
                            type="button"
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(row?._id);
                            }}
                          >
                            <DeleteIcon />
                          </button>
                        </li> */}
                        </ul>
                      </TableCell>
                    </TableRow>
                  ))
                : !loading &&
                  !banners?.length && (
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  )}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          setPage={setPage}
          module={banners}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          totalCount={totalCount}
        />
      </div>
      <WarnModal
        setOpen={setOpen}
        open={open}
        name="banner"
        handleDelete={() => handleDelete(deleteById, selectedId, getAllBanner)}
      />
    </MainContainer>
  );
}
